module.exports = __webpack_public_path__ + "img/glogo239.f1b22e26.png";